import { render } from "./AssistenzaTecnica.vue?vue&type=template&id=4d8f84ee&scoped=true"
import script from "./AssistenzaTecnica.vue?vue&type=script&lang=js"
export * from "./AssistenzaTecnica.vue?vue&type=script&lang=js"

import "./AssistenzaTecnica.vue?vue&type=style&index=0&id=4d8f84ee&scoped=true&lang=css"
import "../../assets/css/staff-ticket-mobile.css?vue&type=style&index=1&id=4d8f84ee&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8f84ee"]])

export default __exports__